var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$style.sectionRoot},[_c('header',{class:_vm.$style.sectionHeader},[_vm._v(" Group Configuration ")]),_c('div',{class:_vm.$style.sectionContent},[_c('div',{class:_vm.$style.inputRow},[_c('InputValidator',{class:_vm.$style.rowSpacing,attrs:{"config":{
          attribute: 'name',
          disabled: _vm.groupNameInputDisabled,
          label: 'Name',
          name: 'name',
          validate: 'required',
          value: _vm.item.name,
        }},on:{"InputValidatorModel":_vm.handleInputChange}}),(_vm.hasGoogleWorkspaceDirectories)?_c('ManagementGroupInput',{attrs:{"parentType":_vm.parentType}}):_vm._e()],1),_c('TextareaValidator',{class:_vm.$style.rowSpacing,attrs:{"config":{
        attribute: 'description',
        label: 'Description',
        name: 'description',
        value: _vm.item.description,
      }},on:{"InputValidatorModel":_vm.handleInputChange}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }